import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import InputField from 'app/components/commonUI/InputField';

export default function AddTagDialog({ open, onClose, onAdd }) {
  const [tagName, setTagName] = useState('');

  const handleAdd = () => {
    if (tagName.trim()) {
      onAdd(tagName.trim());
      setTagName('');
      onClose();
    }
  };

  const handleClose = () => {
    setTagName('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>新しいタグを追加</DialogTitle>
      <DialogContent>
        <div className="pt-2">
          <InputField
            name="tagName"
            value={tagName}
            placeholder="タグ名を入力してください"
            onChange={(value) => setTagName(value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAdd();
              }
            }}
          />
        </div>
      </DialogContent>
      <DialogActions className="px-6 pb-4">
        <button
          type="button"
          onClick={handleClose}
          className="px-6 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
        >
          キャンセル
        </button>
        <button
          type="button"
          onClick={handleAdd}
          className="px-6 py-2 bg-[#0096D4] text-white rounded-lg text-sm hover:bg-[#0085c0]"
          disabled={!tagName.trim()}
        >
          追加
        </button>
      </DialogActions>
    </Dialog>
  );
}
